var store = require('store')

export default function init_favorites() {

    this.init = () => {
        //update favorite count
        this.updateFavoriteCount();
        this.updateFavoriteList();
        let favoriteButtons = document.querySelectorAll('.favorite-btn');
        for (let index = 0; index < favoriteButtons.length; index++) {
            //see if it should be marked as a favorite
            let favorited = isAlreadyFavorited(favoriteButtons[index]);
            if(favorited) {
                favoriteButtons[index].classList.add('favorited');
            } else {
                favoriteButtons[index].classList.remove('favorited');
            }
            favoriteButtons[index].addEventListener('click', this.toggleFavorite, true);  
        }
    }
    
    this.reset = () => {
        this.destroy();
        this.init();
    }

    this.destroy = function () {
        //alert('destroy');
        let favoriteButtons = document.querySelectorAll('.favorite-btn');
        for (let index = 0; index < favoriteButtons.length; index++) {
            favoriteButtons[index].removeEventListener('click', this.toggleFavorite, true);    
        }
    }

    this.toggleFavorite = () => {
        let element = event.target;
        let product = findAncestor(element, '.product');
        let attributes = {};
        [].forEach.call(product.attributes, function(attr) {
            if (/^data-/.test(attr.name)) {
                var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
                    return $1.toUpperCase();
                });
                attributes[camelCaseName] = attr.value;
            }
        });
        //see if it exists in favorites already
        let exists = false;
        let favorites = store.get('favorites');
        if(favorites) {
            if(attributes.id in favorites) {
                exists = true;
            }
        } else {
            favorites = {};
        }
        // console.log(attributes.id, favorites, exists);
        let allButtons = document.querySelectorAll(`.fb-${attributes.id}`);
        if(exists) { //remove it from the array
            delete favorites[attributes.id];
            product.classList.remove('is-favorite');
            for (let index = 0; index < allButtons.length; index++) {
                allButtons[index].classList.remove('favorited');
            }
            element.classList.remove('favorited');
        } else { //add it to the array
            // console.log('add it');
            favorites[attributes.id] = attributes;
            element.classList.add('favorited');
            product.classList.add('is-favorite');
            for (let index = 0; index < allButtons.length; index++) {
                allButtons[index].classList.add('favorited');
            }
            this.pulse();
        }
        store.set('favorites', favorites);
        favorites = store.get('favorites');
        // console.log(favorites);
        //updateFavoritesList();
        this.updateFavoriteList();
        this.updateFavoriteCount();
    }

    this.updateFavoriteCount = function() {
        let favorites = store.get('favorites');
        if(!favorites) {
            favorites = {};
        }
        let numOfFavorites = Object.size(favorites);
        // console.log(numOfFavorites);
        if(numOfFavorites >= 0) {
            let favoritesLinks = document.querySelectorAll('.favorite-count');
            for (let index = 0; index < favoritesLinks.length; index++) {
                favoritesLinks[index].innerHTML = numOfFavorites;
            }
            let favoriteTitles = document.querySelectorAll('.hide-when-no-favorites');
            for (let index = 0; index < favoriteTitles.length; index++) {
                favoriteTitles[index].style.display = 'block';
            }
        }
        if(numOfFavorites == 0) {
            let favoriteTitles = document.querySelectorAll('.hide-when-no-favorites');
            for (let index = 0; index < favoriteTitles.length; index++) {
                favoriteTitles[index].style.display = 'none';
            }
        }
    }

    this.pulse = () => {
        let favoriteButtons = document.querySelectorAll('.favorites-button');
        for (let index = 0; index < favoriteButtons.length; index++) {
            favoriteButtons[index].classList.add('pulse');    
        }
        setTimeout(() => {
            for (let index = 0; index < favoriteButtons.length; index++) {
                favoriteButtons[index].classList.remove('pulse');    
            }
        }, 1200);
    }

    this.updateFavoriteList = () => {
        if(document.querySelector('.favorite-list')){
            let favorites = store.get('favorites');
            let html = '';
            if(favorites) {
                Object.keys(favorites).map( (key, index) => {
                    //console.log(favorites[key]);
                    let item = favorites[key];
                    //console.log(item);
                    if(item.thumbs) {
                        let itemThumbs = item.thumbs.split(',');
                        html = html.concat(`
                            <div class="favorite-list-item">
                                <div class="favorite-list-item--border">
                                    <div class="favorite-image">
                                        <img src="${itemThumbs[0]}" alt="${item.title}">
                                    </div>
                                    <div class="favorite-details">
                                        <div class="favorite-title">${item.title}</div>
                                        <div class="favorite-remove" data-id="${item.id}">Remove</div>
                                        <input type="hidden" name="favorites[]" value="${item.title} - ${item.sport} - ${item.category} - ${item.ogimage}" />
                                    </div>
                                </div>
                            </div>
                        `);
                    } else {
                        console.log('no thumbs', item.thumbs);
                        delete favorites[key];
                        store.set('favorites', favorites);
                        this.updateFavoriteList();
                        this.updateFavoriteCount();
                        return;
                    }
                });
                document.querySelector('.favorite-list').innerHTML = html;
                var removeButtons = document.querySelectorAll('.favorite-remove');
                for (let index = 0; index < removeButtons.length; index++) {
                    // removeButtons[index].classList.add('favorited');
                    removeButtons[index].addEventListener('click', () => {
                        let favorites = store.get('favorites');
                        delete favorites[removeButtons[index].dataset.id];
                        store.set('favorites', favorites);
                        this.updateFavoriteCount();
                        removeButtons[index].parentElement.parentElement.parentElement.remove();
                    }, true);  
                }
            }
        }
    }
    
    return this;
}

function isAlreadyFavorited(element) {
    let product = findAncestor(element, '.product');
    let attributes = {};
    [].forEach.call(product.attributes, function(attr) {
        if (/^data-/.test(attr.name)) {
            var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
                return $1.toUpperCase();
            });
            attributes[camelCaseName] = attr.value;
        }
    });
    let exists = false;
    let favorites = store.get('favorites');
    if(favorites) {
        if(attributes.id in favorites) {
            exists = true;
        }
    } else {
        favorites = {};
    }
    return exists;
}

function findAncestor(el, sel) {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
    return el;
}

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};
